import type {
	Construction,
	SchedulePlannedSpan,
	ScheduleTreeItem,
} from "@/adapters/api";
import type {
	ConstructionSummary,
	ScheduleNode,
	ScheduleSpan,
} from "../types.ts";

function toDateOnly(value: string | null | undefined): string | undefined {
	if (!value) return undefined;
	return value.slice(0, 10);
}

export function toScheduleNode(item: ScheduleTreeItem): ScheduleNode {
	return {
		id: item.stage_id,
		parentId: item.parent_stage_id,
		name: item.name,
		status: item.status,
		position: item.position,
		depth: item.depth,
		ownStart: toDateOnly(item.own_planned_start_date),
		ownEnd: toDateOnly(item.own_planned_end_date),
		start: toDateOnly(item.planned_start_date),
		end: toDateOnly(item.planned_end_date),
		ownActualStart: toDateOnly(item.own_actual_start_date),
		ownActualEnd: toDateOnly(item.own_actual_end_date),
		actualStart: toDateOnly(item.actual_start_date),
		actualEnd: toDateOnly(item.actual_end_date),
		actualSource: item.actual_dates_source ?? "derived",
	};
}

export function toScheduleSpan(span: SchedulePlannedSpan): ScheduleSpan {
	return {
		start: toDateOnly(span.planned_start_date),
		end: toDateOnly(span.planned_end_date),
	};
}

export function toConstructionSummary(c: Construction): ConstructionSummary {
	return {
		id: c.id,
		name: c.name,
		startDate: toDateOnly(c.start_date),
		expectedEndDate: toDateOnly(c.expected_end_date),
	};
}
